const options = {
  5: "bg-neutral-200/5",
  10: "bg-neutral-200/10",
  25: "bg-neutral-200/25",
  50: "bg-neutral-200/50",
  75: "bg-neutral-200/75",
  90: "bg-neutral-200/90",
  100: "bg-neutral-200",
};

const from = {
  5: "from-neutral-200/5",
  10: "from-neutral-200/10",
  25: "from-neutral-200/25",
  50: "from-neutral-200/50",
  75: "from-neutral-200/75",
  90: "from-neutral-200/90",
  100: "from-neutral-200",
};

export default function getBackgroundNeutral200(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
